const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg1145"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      id="path1143"
      fill={color}
      d="M23.25 5.25A2.257 2.257 0 0 0 21 3H3A2.257 2.257 0 0 0 .75 5.25v13.5A2.257 2.257 0 0 0 3 21h18a2.257 2.257 0 0 0 2.25-2.25zm-2.25 0-9 5.625L3 5.25Zm0 13.5H3V7.5l9 5.625L21 7.5z"
    ></path>
  </svg>
);

export default SvgIcon;
